import React from 'react';

const SobreMim = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white py-16 px-4 sm:px-6">
      {/* Seção Principal */}
      <section className="max-w-4xl mx-auto bg-white rounded-2xl p-8 md:p-12 shadow-xl border border-gray-200 mb-12">
        <div className="text-center mb-10">
          <h1 className="text-3xl sm:text-4xl font-bold gradient-text mb-3">
            Um pouco sobre mim
          </h1>
          <div className="h-1 w-24 bg-gradient-to-r from-red-500 to-red-600 mx-auto rounded-full"></div>
        </div>

        <div className="space-y-6 text-gray-700 leading-relaxed">
          <p className="text-lg">
            Me chamo <span className="text-red-600 font-semibold">Eduardo da Silva Fontes</span>, tenho 20 anos, e estou atualmente cursando Desenvolvimento de Software Multiplataforma na FATEC de São José dos Campos, no meu 4º semestre. Tenho familiaridade com o método ágil Scrum, DevOps e desenvolvimento backend e frontend. Meu maior objetivo é me tornar um Desenvolvedor completo e versátil, contribuindo da melhor maneira para o mercado de trabalho, além de contribuir fortemente para a comunidade de programadores. </p>

          <p className="text-lg">
            Sou apaixonado por <span className='text-red-600'>tecnologia</span> desde criança, e essa paixão me levou a explorar o mundo da programação. Adoro desafios que me fazem pensar fora da caixa e encontrar soluções criativas para problemas complexos.
          </p>

          <p className="text-lg">
            No meu tempo livre sempre mantenho um equilibrio entre o estudo de novas tecnologias e o lazer com <span className='text-red-600'>jogos</span>, <span className='text-red-600'>filmes</span>, <span className='text-red-600'>séries</span> ou <span className='text-red-600'>músicas</span>. Amo ter contato com outras culturas, é onde eu posso explorar de forma mais divertida o mundo.
          </p>

          <div className="p-6 bg-gradient-to-r from-red-50 to-white rounded-xl border-l-4 border-red-600 mt-8">
            <p className="text-lg italic text-gray-800">
              Isso de querer ser exatamente aquilo que a gente é, ainda vai nos levar além.<br></br>- Paulo Leminski
            </p>
          </div>
        </div>
      </section>

      {/* Seção Habilidades Técnicas */}
      <section className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden mb-12">
        <div className="p-8 md:p-12">
          <h2 className="text-2xl sm:text-3xl font-bold text-red-600 mb-8 border-b-2 border-gray-200 pb-4">
            O Que Eu Faço
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3 flex items-center">
                <span className="w-2 h-2 bg-red-600 rounded-full mr-3"></span>
                Desenvolvimento Front-end
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Construo interfaces modernas e responsivas com <span className="text-red-600 font-medium">React</span>, <span className="text-red-600 font-medium">TypeScript</span> e <span className="text-red-600 font-medium">Tailwind CSS</span>. Adoro criar experiências que são tão bonitas quanto funcionais.
              </p>
            </div>
            
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3 flex items-center">
                <span className="w-2 h-2 bg-red-600 rounded-full mr-3"></span>
                Desenvolvimento Back-end
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Desenvolvo sistemas robustos utilizando <span className="text-red-600 font-medium">Java</span>, <span className="text-red-600 font-medium">Python</span> e <span className="text-red-600 font-medium">TypeScript</span>. Tenho expertise na construção de <span className="text-red-600 font-medium">APIs REST</span> e integração com frontend através de <span className="text-red-600 font-medium">Node.js</span>, criando arquiteturas escaláveis e eficientes.
              </p>
            </div>
            
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3 flex items-center">
                <span className="w-2 h-2 bg-red-600 rounded-full mr-3"></span>
                Design de Interfaces
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Uso <span className="text-red-600 font-medium">Figma</span> para prototipar e criar designs intuitivos. Acredito que boa UX vai além de pixels, é sobre entender necessidades reais.
              </p>
            </div>
            
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3 flex items-center">
                <span className="w-2 h-2 bg-red-600 rounded-full mr-3"></span>
                Resolução de Problemas
              </h3>
              <p className="text-gray-600 leading-relaxed">
                Gosto de <span className='text-red-600'>desafios</span>! Seja debugando código ou otimizando processos, encaro problemas como oportunidades para aprender e crescer.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Seção Formação */}
      <section className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden">
        <div className="p-8 md:p-12">
          <h2 className="text-2xl sm:text-3xl font-bold text-red-600 mb-8 border-b-2 border-gray-200 pb-4">
            Minha Jornada
          </h2>
          
          <div className="space-y-10">
            <div className="flex items-start">
              <div className="bg-red-100 p-2 rounded-full mr-5 mt-1 flex-shrink-0">
                <div className="w-3 h-3 bg-red-600 rounded-full"></div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-1">Ensino Médio Completo</h3>
                <p className="text-red-600 font-semibold mb-1">Prof. Nelson do Nascimento Monteiro</p>
                <p className="text-gray-500 text-sm font-medium mb-3">2021 - 2023</p>
              </div>
            </div>
            
            <div className="flex items-start">
              <div className="bg-red-100 p-2 rounded-full mr-5 mt-1 flex-shrink-0">
                <div className="w-3 h-3 bg-red-600 rounded-full"></div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-1">Desenvolvimento de Software Multiplataforma</h3>
                <p className="text-red-600 font-semibold mb-1">Fatec Prof. Jessen Vidal - São José dos Campos</p>
                <p className="text-gray-500 text-sm font-medium mb-3">2024 - Atualmente</p>
                <p className="text-gray-600 leading-relaxed">
                  Onde estou aprofundando meus conhecimentos e colocando em prática em projetos reais tudo que aprendo.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SobreMim;